export const OAUTH_PROVIDERS = Object.freeze({
  SAE_PROVIDER_NAME: 'SAE',
  GOOGLE_PROVIDER_NAME: 'Google'
})

export default {
  OAUTH_PROVIDERS
}
